import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';

import { Message } from './message';


export class MessageService {
    private subjectMsg = new Subject<Message>();
    private subjectConfirmed = new Subject<boolean>();

    showMessage(message: Message) {
        this.subjectMsg.next(message);
    }

    confirmMessage(value: boolean, ) {
        this.subjectConfirmed.next(value);
    }

    getMessage(): Observable<any> {
        return this.subjectMsg.asObservable();
    }

    getConfirmed(): Observable<any> {
        return this.subjectConfirmed.asObservable();
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
